import React, { useEffect } from "react";

import LastRowIcon from "web/assets/svg/HowItWork/PalletBuyer"
import SearchIcon from "web/assets/svg/HowItWork/SearchComputer"
import NoteIcon from "web/assets/svg/HowItWork/NoteIcon"
import HandIcon from "web/assets/svg/HowItWork/HandIcon"
import ComputerIcon from "web/assets/svg/HowItWork/ComputerIcon"
import TruckIcon from "web/assets/svg/HowItWork/TruckIcon"
import UploadIcon from "web/assets/svg/HowItWork/UploadIcon"
import MobileIcon from "web/assets/svg/HowItWork/MobileIcon"
import PalletSeller from "web/assets/svg/HowItWork/PalletSeller"
import PalletTraderScreenIcon from "web/assets/svg/HowItWork/PalletTraderScreenIcon"
import FinalIcon from "web/assets/svg/HowItWork/FinalIcon"

import AOS from "aos";
import { useHistory } from "react-router-dom";

import {
  Container,
  Wrapper,
  ToolsWrapper,
  ToolBox,
} from "web/pages/public/landing-page/HowItWork/PowerfullTool/PowerfullToolStyled";

const PowerfullTool = () => {

  let history = useHistory();
  const signUp = () => {
    history.push("/registration");
  };
  useEffect(() => {
    AOS.init({
      duration: 1000,
      offset: 320,
    });
  }, []);
  return (
    <Container data-aos="fade-up" data-aos-delay="400">
      <Wrapper>
        <h4>It's not just a powerful tool to use. It's an easy tool to use.</h4>
        <h5>
          From any desktop or mobile device, PalletTrader harnesses the power of
          an e-commerce marketplace to help you manage your pallet supply. At
          the click of a button, you’ll have unlimited access to the pallets you
          need, and unrestricted access to the markets you want. Any time.
          Anywhere.
        </h5>
        {/* <img src={Technology} alt='Technology' /> */}
        <p className="roll-over"><span>Roll over to follow the PalletTrader path from search to delivery</span></p>
        <ToolsWrapper>
          <ToolBox>
            <div className="box-row first-row">
              <span>Pallet Buyers</span>
              <div>
                <span><LastRowIcon className="pallet-buyer" /></span>
                <span><PalletTraderScreenIcon className="pallet-trader-screen" /></span>
                <span><PalletSeller className="pallet-seller" /></span>
                {/* <span><DummyExplanationMarkIcon /></span>
                <span><DummyExplanationMarkIcon /></span>
                <span><DummyExplanationMarkIcon /></span> */}
              </div>
              <span>Pallet Sellers</span>
              {/* <FirstRowGroupIcon className="first-row-svg" /> */}
              <div className="center-border"></div>
              <div className="bottom-border"></div>
            </div>
            <div className="box-row sec-row">

              <div>
                <div className="icon-wrapper">
                  <SearchIcon className="search-icon" />
                  <SearchIcon className="search-icon" />
                </div>
                <p>Search inventory or post needs</p>
              </div>
              <div>
                <div className="icon-wrapper">
                  <NoteIcon className='note-icon' />
                  <NoteIcon className='note-icon' />
                </div>
                <p>Make offer or
                  receive a bid</p>
              </div>
              <div>
                <div className="icon-wrapper">
                  <HandIcon />
                  <HandIcon />
                </div>
                <p>Offer or
                  bid accepted</p>
              </div>
              <div>
                <div className="icon-wrapper">
                  <ComputerIcon />
                  <ComputerIcon />
                </div>
                <p>Order created</p>
              </div>
              <div>
                <div className="icon-wrapper">
                  <TruckIcon />
                  <TruckIcon />
                </div>
                <p>Pallet delivery</p>
              </div>
              <div>
                <div className="icon-wrapper">
                  <UploadIcon />
                  <UploadIcon />
                </div>
                <p>Proof of delivery</p>
              </div>
              <div>
                <div className="icon-wrapper">
                  <MobileIcon />
                  <MobileIcon />
                </div>
                <p>Payment made</p>
              </div>
              <div className="top-border">
              </div>
              <div className="bottom-border">
              </div>
            </div>
            <div className="box-row third-row">
              <div>
                <span><FinalIcon /></span>
              </div>
            </div>
          </ToolBox>

        </ToolsWrapper>
        <button onClick={signUp}>Sign Me Up</button>
      </Wrapper>
    </Container>
  );
};

export default PowerfullTool;
